import React from "react";
import GamePageTemplate from "../GamePageTemplate";

const CrashPage = () => {
  return (
    <GamePageTemplate
      // pageTitle="Crash Lobby"
      // bannerTitle="Crash Lobby"
      bannerImage="/images/crash-banner.png"
      fetchParams={{ isLiveGame: false }}
      fixedGameType="crash"
      showGameTypeFilter={false}
    />
  );
};

export default CrashPage;
